export default __webpack_public_path__ + "static/media/right.ab009547.svg";